<template>
  <div>
    <DynamicComponent edc-id="polaris-report" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisReport',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
